var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReportTemplate',{attrs:{"loading":!_vm.initialized,"title":"Purchase Order Report","permission":_vm.PERMISSION_CODES.CMS_VIEW_REPORT_INVENTORY_PURCHASE_ORDER,"filters":_vm.filters,"columns":_vm.columns,"fetchRoute":"/reports/purchase-orders","reportTypeCode":_vm.REPORT_MASTER_CODES.PURCHASE_ORDER}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }